var React = require('react');

function U3 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"U3"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},[React.createElement("path",{"d":"M30.38,86a30.36,30.36,0,0,0,24.94-32L52.64,0,25.55,1.94Z","fill":"#f47643","style":{"mixBlendMode":"multiply"},"key":0}),React.createElement("path",{"d":"M28.38,86.41A30.36,30.36,0,0,1,.67,56.72L0,2l27.16-.49Z","fill":"#e5c83d","style":{"mixBlendMode":"multiply"},"key":1})])]);
}

U3.defaultProps = {"viewBox":"0 0 55.4 86.41"};

module.exports = U3;

U3.default = U3;
